<layer-header (closeLayer)="closeLayer()"
              (setListView)="setListView($event)"
              [listToggle]="listToggle"
              [title]="'Laws'">
    <ng-content></ng-content>
</layer-header>
<law-edit *ngIf="topLayer == 'edit'"
           [serviceId]="serviceId"
           [registration]="registration"
           [law]="law"
           [registrationLaw]="registrationLaw"
           (editCancel)="cancelEdit($event);"
           (formSubmit)="submitEdit($event);"
           class="row layer sub-layer px-3 pt-1">
</law-edit>
<div class="row">
    <div class="col-md-1">
    </div>
    <div class="col-lg-12 col-xl-11">
        <!-- Search -->
        <div class="row">
            <div class="col-md-12 col-xl-6">
                <div class="form-controller list-search-container">
                    <i class="fas fa-search list-search-icon"></i>
                    <input type="text"
                           [(ngModel)]="userFilter.name"
                           placeholder="{{ 'general.search' | translate }}"
                           class="form-control list-search-input flew-grow-1">
                    <button class="btn btn-sm btn-primary mr-1"
                       (click)="openEdit(false);$event.stopPropagation();"
                       placement="left"
                       aria-hidden="true">{{'Add' | translate}}</button>
                </div>
            </div>
        </div>
        <!-- Listing -->
        <div class="{{listToggle ? 'cards-list' : 'rows-list'}} row"
             style="margin-bottom:2rem">
            <div *ngFor="let law of laws | filterBy: userFilter; let i = index"
                 class="nglist-item {{listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-6'}}"
                 (click)="openEdit(law);$event.stopPropagation();">
                <div class="nglist-item-content">
                    <span class="nglist-item-content-title">
                      {{law.name}}
                    </span>
                </div>
                <div class="nglist-item-actions alternate">
                    <icon style="margin-inline-end:0.5rem;"
                          className="far fa-circle toggle__icon"
                          *ngIf="!isActive(law)"
                          (click)="saveRegistrationLaw(law);$event.stopPropagation()"></icon>
                    <icon style="margin-inline-end: 0.5rem;color:#8ecb35;cursor:pointer"
                          className="fas fa-check icon-success"
                          *ngIf="isActive(law)"
                          (click)="deleteRegistrationLaw(law);$event.stopPropagation()"></icon>
                    <confirmation [showTrashIcon]="true"
                                  [question]="'confirm.areyousure'"
                                  [extraClasses]="'nglist-item-action'"
                                  (click)="$event.stopPropagation()"
                                  (isConfirmed)="deleteLaw($event, law)"></confirmation>
                </div>
            </div>
        </div>
    </div>
</div>